export const GOOGLE_ADS_VARIABLE = `
var googletag = googletag || {};
googletag.cmd = googletag.cmd || [];`;

export const GOOGLE_ADS_AUTO_RESIZE_SCRIPT = `
// helper function to debounce function
var debounce = (func, timeout = 300) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

// helper function to extract all possible ad sizes defined in a size mapping
// this way you won't have to list them when defining ad slots and avoids mistakes
// and ads that are not listed in the size mapping won't be served
var getAllAdSizes = (sizeMapping) => {
  const allSizes = []

  sizeMapping.forEach((sizeMap) => {
    sizeMap[1].forEach((size) => {
      allSizes.push(size)
    })
  })

  return [...new Set(allSizes.map((item) => JSON.stringify(item)))].map(
    (item) => JSON.parse(item)
  )
}

document.addEventListener('DOMContentLoaded', (e) => {
  const refreshAds = debounce(() => {
    // this can be more optimized, right now it refreshes all ad slots but you can also refresh specific slots based on the current breakpoint
    // you'd have to look at the different size mappings to see which slots are using that sizemapping and should be refreshed
    // refresh functions is throttled by google if you do it too many times in a row, so repeatedly resizing your window will delay the refresh
    // that is why it is best to debounce this function
    // more info: https://developers.google.com/publisher-tag/guides/control-ad-loading#best_practices
    googletag.cmd.push(() => {
      googletag.pubads().refresh()
    })
  }, 1000)
  if(typeof adBreakpoints !== 'undefined'){
    for (const [id, breakpoint] of Object.entries(adBreakpoints)) {
      const mql = window.matchMedia(breakpoint.mq)
      mql.onchange = debounce((e) => {
        if (e.matches) {
          refreshAds()
        }
      },1000);
    }
  }
})

var adSlotsBorder = () => { return googletag.cmd.push(() => {
  googletag.pubads().addEventListener('slotOnload', (e) => {
    const slotElement = document.getElementById(e.slot.getSlotElementId())
    if (slotElement) {
      slotElement.parentElement.classList.add('ad-label')
    }
  })
})}`;

export const GOOGLE_ADS_AUTO_RESIZE_SCRIPT_WITH_TIMEOUT = `
// helper function to debounce function
var debounce = (func, timeout = 300) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

// helper function to extract all possible ad sizes defined in a size mapping
// this way you won't have to list them when defining ad slots and avoids mistakes
// and ads that are not listed in the size mapping won't be served
var getAllAdSizes = (sizeMapping) => {
  const allSizes = []

  sizeMapping.forEach((sizeMap) => {
    sizeMap[1].forEach((size) => {
      allSizes.push(size)
    })
  })

  return [...new Set(allSizes.map((item) => JSON.stringify(item)))].map(
    (item) => JSON.parse(item)
  )
}

document.addEventListener('DOMContentLoaded', (e) => {
  const refreshAds = debounce(() => {
    // this can be more optimized, right now it refreshes all ad slots but you can also refresh specific slots based on the current breakpoint
    // you'd have to look at the different size mappings to see which slots are using that sizemapping and should be refreshed
    // refresh functions is throttled by google if you do it too many times in a row, so repeatedly resizing your window will delay the refresh
    // that is why it is best to debounce this function
    // more info: https://developers.google.com/publisher-tag/guides/control-ad-loading#best_practices
    if (window.scShowAds == true) {
      googletag.cmd.push(() => {
        googletag.pubads().refresh()
      })
    }
  }, 1000)
  if(typeof adBreakpoints !== 'undefined'){
    for (const [id, breakpoint] of Object.entries(adBreakpoints)) {
      const mql = window.matchMedia(breakpoint.mq)
      mql.onchange = debounce((e) => {
        if (e.matches) {
          refreshAds()
        }
      },1000);
    }
  }
})

var adSlotsBorder = () => { return googletag.cmd.push(() => {
  googletag.pubads().addEventListener('slotOnload', (e) => {
    const slotElement = document.getElementById(e.slot.getSlotElementId())
    if (slotElement) {
      slotElement.parentElement.classList.add('ad-label')
    }
  })
})}`;

export const MINIMUM_AD_SPACING = 400;
export const AVERAGE_HORIZONTAL_AD_HEIGHT = 150;
export const AVERAGE_VERTICAL_AD_HEIGHT = 600;

export const HORIZONTAL_ADS_CONTAINER_ID = {
  WHAT_IS_PAGE_IN_CONTENT: 'what-is_page_in-content',
  DOSAGE_PAGE_IN_CONTENT: 'dosage_page_in_content',
  CONDITIONS_TREATMENT_PAGE_IN_CONTENT: 'conditions-treatment_page_in_content',
  CONDITIONS_ADD_ON_PAGE_IN_CONTENT: 'conditions-add-on_page_in_content',
  DRUG_CLASSES_PAGE_IN_CONTENT: 'drug-classes_page_in_content'
};

export const VERTICAL_ADS_CONTAINER_ID = {
  WHAT_IS_PAGE_RIGHT_SIDE: 'what-is_page_right_side',
  WHAT_IS_PAGE_LEFT_SIDE: 'what-is_page_left_side',
  DOSAGE_PAGE_RIGHT_SIDE: 'dosage_page_right_side',
  CONDITIONS_TREATMENT_PAGE_RIGHT_SIDE: 'conditions-treatment_page_right_side',
  CONDITIONS_TREATMENT_PAGE_LEFT_SIDE: 'conditions-treatment_page_left_side',
  CONDITION_ADD_ON_PAGE_RIGHT_SIDE: 'conditions-add-on_page_right_side',
  CONDITION_ADD_ON_PAGE_LEFT_SIDE: 'conditions-add-on_page_left_side',
  DRUG_CLASSES_PAGE_LEFT_SIDE: 'drug-classes_page_left_side',
  DRUG_CLASSES_PAGE_RIGHT_SIDE: 'drug-classes_page_right_side'
};

export const BOTTOM_ANCHOR_AD_CONTAINER_ID = {
  WHAT_IS_PAGE: 'what-is_page_bottom_anchor',
  DOSAGE_PAGE: 'dosage_page_bottom_anchor',
  CONDITIONS_TREATMENT_PAGE: 'conditions-treatment_page_bottom_anchor',
  CONDITIONS_ADD_ON_PAGE: 'condition-add-on_page_bottom_anchor',
  DRUG_CLASSES_PAGE: 'drug-classes_page_bottom_anchor'
};
